"use client";
import React, { ReactNode, Ref, useState } from "react";
import DropdownTrigger from "./dropdownTrigger";
import DropdownList from "./dropdownList";
import { useClickAway } from "@uidotdev/usehooks";
import { VariantProps } from "class-variance-authority";
import { dropdownVariants } from "@/styles/variants";
import { cn } from "@/lib";

interface DropdownProps extends VariantProps<typeof dropdownVariants> {
  items: string[];
  value: string;
  onChange: (value: string) => void;
  startIcon?: ReactNode;
  className?: string;
  searchable?: boolean;
  onSearch?: (query: string) => void;
  searchValue?: string;
  placeholder?: string;
}

const Dropdown: React.FC<DropdownProps> = ({
  items,
  value,
  onChange,
  variant,
  startIcon,
  className,
  searchable = false,
  onSearch,
  searchValue = "",
  placeholder = "جستجو...",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useClickAway(() => {
    setIsOpen(false);
    if (searchable && onSearch) {
      onSearch("");
    }
  }) as Ref<HTMLDivElement> | undefined;

  const handleSelect = (item: string) => {
    setIsOpen(false);
    onChange(item);
    if (searchable && onSearch) {
      onSearch("");
    }
  };

  return (
    <div className={cn("relative h-full w-max", className)} ref={ref}>
      <DropdownTrigger
        label={value || placeholder}
        isOpen={isOpen}
        onClick={() => setIsOpen((prev) => !prev)}
        variant={variant}
        startIcon={startIcon}
      />
      {isOpen && (
        <DropdownList
          items={items}
          onSelect={handleSelect}
          searchable={searchable}
          onSearch={onSearch}
          searchValue={searchValue}
        />
      )}
    </div>
  );
};

export default Dropdown;
